import { AbiItem } from 'web3-utils';

import erc20 from './erc20.abi.json';
import vesting from './vesting.abi.json';

export const erc20Abi = erc20 as AbiItem[];
export const vestingAbi = vesting as AbiItem[];
